const INTERACTION_ITEM_MAPPING = {
  call: 'Call',
  chat: 'Chat',
};

export default INTERACTION_ITEM_MAPPING;
